import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MapPin, Phone, Clock } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LocationsPage() {
  const [locations, setLocations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/locations`).then(res => { setLocations(res.data); setIsLoading(false); }).catch(() => setIsLoading(false));
  }, []);

  return (
    <div className="pt-20" data-testid="locations-page">
      <section className="py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <motion.div className="text-center mb-16" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <p className="text-uf-red font-heading text-xl tracking-[0.3em] mb-2">FIND US</p>
            <h1 className="font-heading text-5xl md:text-7xl font-bold text-white">Our Locations</h1>
            <p className="text-uf-textMuted text-lg mt-4 max-w-2xl mx-auto">11 premium facilities across the UK and Greece.</p>
          </motion.div>
          {isLoading ? <div className="text-center text-uf-textMuted">Loading...</div> : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {locations.map((location, index) => (
                <motion.div key={location.id} className="location-card" initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.1 }} data-testid={`location-${location.id}`}>
                  <div className="aspect-[16/10] overflow-hidden"><img src={location.image_url} alt={location.name} className="w-full h-full object-cover location-image" /></div>
                  <div className="p-6">
                    <h3 className="font-heading text-2xl font-bold text-white mb-2">{location.name}</h3>
                    <div className="space-y-2 text-sm text-uf-textMuted">
                      <p className="flex items-center gap-2"><MapPin size={14} className="text-uf-red" />{location.address}, {location.city}</p>
                      <p className="flex items-center gap-2"><Phone size={14} className="text-uf-red" />{location.phone}</p>
                      <p className="flex items-center gap-2"><Clock size={14} className="text-uf-red" />{location.hours}</p>
                    </div>
                    <div className="flex flex-wrap gap-2 mt-4">
                      {location.features.slice(0, 3).map(feat => <span key={feat} className="text-xs bg-uf-surfaceHi px-3 py-1 text-uf-textMuted">{feat}</span>)}
                    </div>
                    <Link to={`/book-tour?location=${location.id}`} className="block mt-4 text-center py-3 border border-uf-red text-uf-red font-heading font-bold uppercase tracking-wider hover:bg-uf-red hover:text-white transition-colors">
                      Book a Tour
                    </Link>
                  </div>
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
